import { currencyFormatter } from 'helpers/formatHelper';
import { formatHours } from 'routes/HumanResourcesModule/PayState/helpers/formatHelpers';
import { DataPointT } from '../../components/PayStateBanner';
import { TableSupCompIndicatorsT } from '../../helpers/hooks/payStateIndicators';

export const formatSupCompTableIndicatorsForBanner = (
    indicators: TableSupCompIndicatorsT | undefined,
): DataPointT[] => {
    if (indicators === undefined) return [];
    const first: DataPointT = {
        current: indicators.currentExercice.totalHoursCount,
        deltaFormatted: formatHours(
            indicators.currentExercice.totalHoursCount -
                (indicators.previousExercice
                    ? indicators.previousExercice.totalHoursCount
                    : 0),
        ),
        ...(indicators.previousExercice
            ? {
                  previous: indicators.previousExercice.totalHoursCount,
              }
            : {}),
    };
    const second: DataPointT = {
        current: indicators.currentExercice.totalHoursCost,
        deltaFormatted: currencyFormatter(
            indicators.currentExercice.totalHoursCost -
                (indicators.previousExercice
                    ? indicators.previousExercice.totalHoursCost
                    : 0),
        ),
        ...(indicators.previousExercice
            ? {
                  previous: indicators.previousExercice.totalHoursCost,
              }
            : {}),
    };
    return [first, second];
};
